import * as React from 'react'
import { Icon, InformationIcon } from '@paypalcorp/pp-react'

type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export const AlertIcon = ({ iconsSize }: { iconsSize: string }) => (
  <InformationIcon size={(iconsSize ? iconsSize : 'md') as Size} />
)
